import { getPageLinkForSlug } from '~~/helpers/routes/getPageInformation';
import { DEFAULT_REDIRECTION_CODE } from '~~/constants/seo';

export default defineNuxtRouteMiddleware((to) => {

  const slug = to.path;
  const redirectPath = getPageLinkForSlug(slug);

  if (slug !== redirectPath) {

    return navigateTo({ path: redirectPath, query: to.query }, {
      redirectCode: DEFAULT_REDIRECTION_CODE,
    });
  
  }

});
